import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-174752c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, " コンパイルエラーはコンソールを見てください。 ", -1 /* HOISTED */))
const _hoisted_2 = {
  key: 0,
  class: "description"
}
const _hoisted_3 = {
  key: 1,
  class: "description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabButton = _resolveComponent("TabButton")!
  const _component_TabGroup = _resolveComponent("TabGroup")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Space = _resolveComponent("Space")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createBlock(_component_Space, {
    vertical: "",
    xlarge: "",
    full: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_TabGroup, null, {
        default: _withCtx(() => [
          _createVNode(_component_TabButton, {
            modelValue: _ctx.tab,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
            value: "animation"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" アニメーション (js) ")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"]),
          _createVNode(_component_TabButton, {
            modelValue: _ctx.tab,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event)),
            value: "effect"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" エフェクト (js) ")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"]),
          _createVNode(_component_TabButton, {
            modelValue: _ctx.tab,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tab) = $event)),
            value: "webgl"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" エフェクト (glsl) ")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Fieldset, { label: "ソース" }, {
        default: _withCtx(() => [
          _createVNode(_component_Space, {
            vertical: "",
            full: ""
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              (_ctx.tab === 'animation')
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, " args: keyframe, ctx, image, offsetH, offsetV, width, height, cellWidth, cellHeight "))
                : _createCommentVNode("v-if", true),
              (_ctx.tab === 'effect')
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, " args: keyframe, ctx, cellWidth, cellHeight "))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_Textarea, {
                modelValue: _ctx.source[_ctx.tab],
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.source[_ctx.tab]) = $event)),
                block: "",
                rows: 20
              }, null, 8 /* PROPS */, ["modelValue"]),
              _createVNode(_component_Button, { onClick: _ctx.build }, {
                default: _withCtx(() => [
                  _createTextVNode(" 適用 ")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Fieldset, { label: "デバッグ" }, {
        default: _withCtx(() => [
          _createVNode(_component_Checkbox, {
            "model-value": _ctx.noCrop,
            name: "余白を切らない",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:noCrop', $event)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString("余白を切らない"))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["model-value"])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_Button, {
        type: "text",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
      }, {
        icon: _withCtx(() => [
          _createTextVNode(" ↩︎ ")
        ]),
        default: _withCtx(() => [
          _createTextVNode(" 開発者モードを終わる ")
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}